import { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { LANGS } from "../i18n/translations";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="language-switcher-btn"
        aria-label="Seleziona lingua"
        className="flex items-center gap-1.5 text-sm text-zinc-300 hover:text-white transition-colors"
      >
        <Globe className="h-4 w-4" />
        <span>{current.short}</span>
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-3 w-40 bg-zinc-900 border border-white/15 py-1 z-50 shadow-xl"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              data-testid={`lang-option-${l.code}`}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-sm transition-colors hover:bg-white/10 ${
                l.code === lang ? "text-white" : "text-zinc-400"
              }`}
            >
              {l.label}
              {l.code === lang && <Check className="h-3.5 w-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
